module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_tag_more.f6181.png";